import { render, staticRenderFns } from "./BankViewBankInfoCard.vue?vue&type=template&id=5dd772d2"
import script from "./BankViewBankInfoCard.vue?vue&type=script&lang=js"
export * from "./BankViewBankInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports